module.exports = __webpack_public_path__ + "static/media/hemoglobin-top.8ed649c9.png";